<template>
    <div>
        <v-data-table
            :headers="headersProperties"
            :items="items"
            :loading="load"
            hide-default-footer
        >

            <template v-slot:[`item.propertyDGWs`]="{ item }">
                <span v-if="!item.update">
                {{
                    item.propertyDGWs.map(item => {
                    if (item.dataGetWay) return item.dataGetWay.wayName
                    }).join(', ')
                }}
                </span>
            </template>

            <template v-slot:[`item.propertyMediaLinks`]="{ item }">
                <div class="text-center" v-for="file in item.propertyMediaLinks" :key="'A'+file.mediaFileId">
                <video class="video" v-if="file.mediaFile.fileUrl.indexOf('.mp4') > -1" controls>
                    <source :src="apiImg + file.mediaFile.fileUrl" type="video/mp4">
                </video>

                <audio class="" v-if="file.mediaFile.fileUrl.indexOf('.mp3') > -1" controls style="display: initial; width:400px">
                    <source :src="apiImg + file.mediaFile.fileUrl" type="audio/mpeg">
                    <source :src="apiImg + file.mediaFile.fileUrl" type="audio/ogg">
                    <source :src="apiImg + file.mediaFile.fileUrl" type="audio/wav">
                </audio>

                <v-img
                    class="link mini"
                    @click="viewing(file)" v-if="link(file) && file.mediaFile.fileUrl.indexOf('.png') > -1 || file.mediaFile.fileUrl.indexOf('.jpg') > -1 || file.mediaFile.fileUrl.indexOf('.jpeg') > -1"
                    :alt="file.mediaFile.fileName"
                    :src="apiImg + file.mediaFile.fileUrl"
                    aspect-ratio="2.3"
                />
                </div>
            </template>

        </v-data-table>


        <v-dialog
            v-model="popup.open"
            max-width="90%"
            height="90%"
        >
            <v-card>
                <v-card-title class="text-h5">
                    <div class="add-files_header">
                        <h2>{{popup.title}}</h2>
                        <button class="filter-btn" @click="closeViewing()">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L13.7279 13.7279" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
                            <path d="M1 14L13.7279 1.27208" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        </button>
                    </div>
                </v-card-title>

                <v-card-text class="d-flex">
                    <img height="600" class="image-pop" v-if="popup.image" :src="popup.file" alt="">
                    <iframe width="100%" height="600" class="image" v-else :src="popup.file" frameborder="0"></iframe>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from "lodash";

export default {
    props: {
        load: { type: Boolean, default: () => true },
        items: { type: Array, default: () => [] }
    },
    computed: {
        ...mapGetters({
            apiImg: 'apiImg'
        }),
    },
    data: () => ({
        popup: {
            open: false,
            image: true,
            title: '',
            file: ''
        },
        headersProperties: [
            {
                text: 'Показатель',
                align: 'center',
                value: 'indicatorName'
            },
            { text: 'Значение', value: 'indicatorValue', align: 'center', sortable: false },
            { text: 'Способ получения информации', value: 'propertyDGWs', align: 'center', sortable: false },
            { text: 'Файл', value: 'propertyMediaLinks', align: 'center', width: 500, sortable: false },
        ]
    }),
    methods: {
        viewing(item) {
            const type = _.last(item.mediaFile.fileUrl.split('.'))
            if (type === 'webb'||type === 'png'||type === 'jpg'|| type === 'jpeg') {
                this.popup.image = true
            } else {
                this.popup.image = false
            }
            this.popup.open = true
            this.popup.title = item.mediaFile.fileName
            this.popup.file = `${this.apiImg}${item.mediaFile.fileUrl}`
        },
        link(file) {
            const type = _.last(file.mediaFile.fileName.split('.'))
            return type !== 'docx'
        }
    }
}
</script>